import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0632 = React.lazy(() => import('./symbols/0632_security_lock'));
const Symbol0633 = React.lazy(() => import('./symbols/0633_security_lock_unlocked'));
const Symbol0634 = React.lazy(() => import('./symbols/0634_security_lock_key'));
const Symbol0635 = React.lazy(() => import('./symbols/0635_anti_virus_protection_shield'));
const Symbol0636 = React.lazy(() => import('./symbols/0636_software_bug_code_vulnerability'));
const Symbol0637 = React.lazy(() => import('./symbols/0637_fingerprint_scan_security_access'));
const Symbol0638 = React.lazy(() => import('./symbols/0638_network_firewall'));
const Symbol0639 = React.lazy(() => import('./symbols/0639_safe_security_lock'));
const Symbol0640 = React.lazy(() => import('./symbols/0640_security_lock_protected'));
const Symbol0641 = React.lazy(
  () => import('./symbols/0641_police_protection_sheriff_security_badge')
);
const Symbol0642 = React.lazy(() => import('./symbols/0642_camera_video_surveillacance_security'));
const Symbol0643 = React.lazy(() => import('./symbols/0643_camera_video_surveillacance_security'));
const Symbol0644 = React.lazy(() => import('./symbols/0644_suitcase_lock_security'));
const Symbol0645 = React.lazy(() => import('./symbols/0645_atm_passcode_keypad_password_access'));
const Symbol0646 = React.lazy(
  () => import('./symbols/0646_secret_passcode_keypad_password_access')
);
const Symbol0647 = React.lazy(() => import('./symbols/0647_fingerprint_iphone_scan_access'));
const Symbol0648 = React.lazy(
  () => import('./symbols/0648_secret_passcode_keypad_password_access')
);
const Symbol0649 = React.lazy(
  () => import('./symbols/0649_secret_passcode_keypad_password_access')
);
const Symbol0650 = React.lazy(() => import('./symbols/0650_gun_security_arms_police'));

export interface IProps {}

const Security: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0632_security_lock" symbol={<Symbol0632 />} />
      <LazySymbol id="0633_security_lock_unlocked" symbol={<Symbol0633 />} />
      <LazySymbol id="0634_security_lock_key" symbol={<Symbol0634 />} />
      <LazySymbol id="0635_anti_virus_protection_shield" symbol={<Symbol0635 />} />
      <LazySymbol id="0636_software_bug_code_vulnerability" symbol={<Symbol0636 />} />
      <LazySymbol id="0637_fingerprint_scan_security_access" symbol={<Symbol0637 />} />
      <LazySymbol id="0638_network_firewall" symbol={<Symbol0638 />} />
      <LazySymbol id="0639_safe_security_lock" symbol={<Symbol0639 />} />
      <LazySymbol id="0640_security_lock_protected" symbol={<Symbol0640 />} />
      <LazySymbol id="0641_police_protection_sheriff_security_badge" symbol={<Symbol0641 />} />
      <LazySymbol id="0642_camera_video_surveillacance_security" symbol={<Symbol0642 />} />
      <LazySymbol id="0643_camera_video_surveillacance_security" symbol={<Symbol0643 />} />
      <LazySymbol id="0644_suitcase_lock_security" symbol={<Symbol0644 />} />
      <LazySymbol id="0645_atm_passcode_keypad_password_access" symbol={<Symbol0645 />} />
      <LazySymbol id="0646_secret_passcode_keypad_password_access" symbol={<Symbol0646 />} />
      <LazySymbol id="0647_fingerprint_iphone_scan_access" symbol={<Symbol0647 />} />
      <LazySymbol id="0648_secret_passcode_keypad_password_access" symbol={<Symbol0648 />} />
      <LazySymbol id="0649_secret_passcode_keypad_password_access" symbol={<Symbol0649 />} />
      <LazySymbol id="0650_gun_security_arms_police" symbol={<Symbol0650 />} />
    </>
  );
});

Security.displayName = 'Security';

export default Security;
